import type { PaymentTerm } from '@makemydeal/dr-platform-types';
import { ACQUISITION_FEE_ID } from '../../constants/payment';

export function getDealerAcquisitionFeeFromTerm(term: PaymentTerm | undefined) {
    if (!term) return undefined;
    return term.dealerFees?.find(
        ({ dealerFeeTypeCode }: { dealerFeeTypeCode: number }) => dealerFeeTypeCode === ACQUISITION_FEE_ID
    );
}
